import { render } from "./AutoLoginForm.vue?vue&type=template&id=25c9fb7e"
import script from "./AutoLoginForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AutoLoginForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script